import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("alphapeps_cart")) || [];
    } catch {
      return [];
    }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("alphapeps_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    const cap = product.stock ?? 20;
    setItems((prev) => {
      const existing = prev.find((i) => i.id === product.id);
      if (existing) {
        return prev.map((i) => (i.id === product.id ? { ...i, qty: Math.min(i.qty + qty, i.stock ?? cap) } : i));
      }
      return [...prev, { id: product.id, name: product.name, price: product.price, dose: product.dose, code: product.code, stock: product.stock, qty: Math.min(qty, cap) }];
    });
    setDrawerOpen(true);
  };

  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));

  const setQty = (id, qty) => {
    if (qty < 1) return removeItem(id);
    setItems((prev) => prev.map((i) => (i.id === id ? { ...i, qty: Math.min(qty, i.stock ?? 20) } : i)));
  };

  const clearCart = () => setItems([]);

  const { subtotal, count } = useMemo(() => {
    return {
      subtotal: items.reduce((s, i) => s + i.price * i.qty, 0),
      count: items.reduce((s, i) => s + i.qty, 0),
    };
  }, [items]);

  return (
    <CartContext.Provider
      value={{ items, addItem, removeItem, setQty, clearCart, subtotal, count, drawerOpen, setDrawerOpen }}
    >
      {children}
    </CartContext.Provider>
  );
}
